// Single source of truth for the app shell navigation (sidebar, mobile
// bottom bar and page titles). `bottom: true` items appear in the mobile
// bottom bar; `short` is the label used there.

import { USER_ROLES } from "../admin/userRoles";

export function getUserType() {
  const uType = localStorage.getItem("uType");
  if (uType === "777" || uType === "779") return "admin";
  if (uType === "772") return "user";
  if (uType === "7741") return "clerk";
  if (uType === "7742") return "superint";
  if (uType === "7771") return "adminclerk";
  if (uType === "7772") return "adminsuperint";
  if (uType === "7773") return "dcf";
  return "division";
}

// Role name for the logged-in staff account (e.g. "DFO Clerk"); "" for applicants.
export function getRoleDisplayName() {
  const uType = localStorage.getItem("uType");
  if (uType === "772") return "";
  const role = USER_ROLES.find((r) => String(r.uType) === uType);
  return role ? role.singular : "";
}

export function isSuperAdmin() {
  return localStorage.getItem("uType") === "779";
}

export const panelLabels = {
  admin: "Admin Panel",
  division: "Division Panel",
  user: "Nature Camp Booking",
  clerk: "DFO Clerk",
  superint: "DFO MH",
  adminclerk: "CWW Clerk",
  adminsuperint: "CWW MH",
  dcf: "CWW DCF",
};

const menus = {
  admin: [
    { section: "Overview", name: "Dashboard", short: "Home", route: "/DashboardPage", icon: "mdi-view-dashboard-outline", bottom: true },
    { section: "Overview", name: "Profile", route: "/profilepage", icon: "mdi-account-circle-outline" },
    { section: "Applications", name: "Pending Applications", short: "Pending", route: "/PendingApplicationsAdmin", icon: "mdi-clock-outline", bottom: true, hideForSuperAdmin: true },
    { section: "Applications", name: "Applications", short: "Apps", route: "/AdminBookinsPage", icon: "mdi-file-document-multiple-outline", bottom: true },
    { section: "Applications", name: "Namudekeralam Applications", short: "Namude", route: "/NamudekeralamApplications", icon: "mdi-tree-outline", superAdminOnly: true },
    { section: "Applications", name: "Approved Applications", route: "/ApprovedApplicationsAdmin", icon: "mdi-check-decagram-outline" },
    { section: "Applications", name: "Cancelled Applications", route: "/CancelledApplicationAdmin", icon: "mdi-close-circle-outline" },
    { section: "Applications", name: "Completed Payments", route: "/completed-payments", icon: "mdi-cash-check" },
    { section: "Applications", name: "Payment Log", route: "/payment-log", icon: "mdi-receipt-text-outline" },
    { section: "Applications", name: "Held Draft Applications", route: "/held-draft-applications", icon: "mdi-timer-sand", superAdminOnly: true },
    { section: "Nature Camps", name: "Manage Nature Camps", short: "Camps", route: "/addcamp", icon: "mdi-pine-tree", bottom: true },
    {
      section: "Users & Access",
      name: "Users List",
      icon: "mdi-account-group-outline",
      superAdminOnly: true,
      children: [
        { name: "All Users", route: "/admin-users-list", icon: "mdi-account-group-outline" },
        ...USER_ROLES.map((role) => ({ name: role.label, route: `/users/${role.key}`, icon: role.icon })),
      ],
    },
    {
      section: "Users & Access",
      name: "Users List",
      icon: "mdi-account-group-outline",
      adminOnly: true,
      children: [
        { name: "CWW Clerks", route: "/AddClerk", icon: "mdi-badge-account" },
        { name: "CWW MHs", route: "/AddSuperint", icon: "mdi-account-tie-outline" },
        { name: "CWW DCF", route: "/AddDcf", icon: "mdi-account-star-outline" },
      ],
    },
    { section: "Users & Access", name: "E-Treasury Office Code", route: "/division-code", icon: "mdi-pound-box-outline" },
  ],
  division: [
    { section: "Overview", name: "Dashboard", short: "Home", route: "/divisiondashboard", icon: "mdi-view-dashboard-outline", bottom: true },
    { section: "Overview", name: "Profile", route: "/profilepage", icon: "mdi-account-circle-outline" },
    { section: "Applications", name: "Pending Applications", short: "Pending", route: "/DivisionMybooking", icon: "mdi-clock-outline", bottom: true },
    { section: "Applications", name: "Applications", short: "Apps", route: "/ApplicationDivision", icon: "mdi-file-document-multiple-outline", bottom: true },
    { section: "Applications", name: "Approved Applications", route: "/ApprovedApplications", icon: "mdi-check-decagram-outline" },
    { section: "Applications", name: "Cancel Requests", route: "/CancelRequest", icon: "mdi-cancel" },
    { section: "Applications", name: "Cancelled Applications", route: "/CancelledApplicationDivision", icon: "mdi-close-circle-outline" },
    { section: "Nature Camps", name: "Nature Camps", short: "Camps", route: "/divisionNatureCamp", icon: "mdi-pine-tree", bottom: true },
    {
      section: "Staff",
      name: "Users List",
      icon: "mdi-account-group-outline",
      children: [
        { name: "DFO Clerks", route: "/sectionclerk", icon: "mdi-account-tie" },
        { name: "DFO MHs", route: "/superintedent", icon: "mdi-account-star" },
      ],
    },
    // { section: "Staff", name: "E-Treasury Office Code", route: "/division-code-details", icon: "mdi-pound-box-outline" },
  ],
  user: [
    { name: "Nature Camps", short: "Camps", route: "/NatureCamps", icon: "mdi-pine-tree", bottom: true },
    { name: "Draft Applications", short: "Drafts", route: "/DraftApplications", icon: "mdi-file-edit-outline", bottom: true },
    { name: "Submitted Applications", short: "Submitted", route: "/SubmittedApplications", icon: "mdi-file-document-check-outline", bottom: true },
    { name: "Forwarded Applications", short: "Forwarded", route: "/ForwardedApplications", icon: "mdi-send-outline", bottom: true },
    { name: "Approved Applications", short: "Approved", route: "/ApprovedApplicationsUser", icon: "mdi-check-decagram-outline", bottom: true },
    { name: "Cancellation Requests", short: "Cancel Req", route: "/CancellationRequests", icon: "mdi-cancel" },
    { name: "Cancelled Applications", short: "Cancelled", route: "/cancelledapplications", icon: "mdi-close-circle-outline", bottom: true },
  ],
  clerk: [
    { name: "Dashboard", short: "Home", route: "/ClerkDashboard", icon: "mdi-view-dashboard-outline", bottom: true },
    { name: "Profile", route: "/profilepage", icon: "mdi-account-circle-outline" },
    { name: "Pending Applications", short: "Pending", route: "/ClerkHome", icon: "mdi-clock-outline", bottom: true },
    { name: "Applications", short: "Apps", route: "/AllApplicationsClerk", icon: "mdi-file-document-multiple-outline" },
    { name: "Approved Applications", route: "/ApprovedApplicationsClerk", icon: "mdi-check-decagram-outline" },
    { name: "Cancel Requests", short: "Cancel Req", route: "/CancelRequestClerk", icon: "mdi-cancel" },
    { name: "Cancelled Applications", short: "Cancelled", route: "/CancelledApplicationClerk", icon: "mdi-close-circle-outline", bottom: true },
  ],
  superint: [
    { name: "Dashboard", short: "Home", route: "/SuperintedentDashboard", icon: "mdi-view-dashboard-outline", bottom: true },
    { name: "Profile", route: "/profilepage", icon: "mdi-account-circle-outline" },
    { name: "Pending Applications", short: "Pending", route: "/SuperintedentHome", icon: "mdi-clock-outline", bottom: true },
    { name: "Applications", short: "Apps", route: "/AllApplicationsSuperint", icon: "mdi-file-document-multiple-outline" },
    { name: "Approved Applications", short: "Approved", route: "/ApplicationSuperintedent", icon: "mdi-check-decagram-outline", bottom: true },
    { name: "Cancelled Applications", short: "Cancelled", route: "/CancelledApplicationSuperintedent", icon: "mdi-close-circle-outline", bottom: true },
  ],
  adminclerk: [
    { name: "Dashboard", short: "Home", route: "/cwwclerkdashboard", icon: "mdi-view-dashboard-outline", bottom: true },
    { name: "Profile", short: "Profile", route: "/profilepage", icon: "mdi-account-circle-outline", bottom: true },
    { name: "Pending Applications", short: "Pending", route: "/AdminClerk", icon: "mdi-clock-outline", bottom: true },
    { name: "Applications", short: "Apps", route: "/AllApplicationsCwwclerk", icon: "mdi-file-document-multiple-outline", bottom: true },
    { name: "Approved Applications", route: "/ApprovedApplicationsCwwclerk", icon: "mdi-check-decagram-outline" },
    { name: "Cancelled Applications", route: "/CancelledApplicationCwwclerk", icon: "mdi-close-circle-outline" },
  ],
  adminsuperint: [
    { name: "Dashboard", short: "Home", route: "/CwwministerialDashboard", icon: "mdi-view-dashboard-outline", bottom: true },
    { name: "Profile", short: "Profile", route: "/profilepage", icon: "mdi-account-circle-outline", bottom: true },
    { name: "Pending Applications", short: "Pending", route: "/AdminMinisterialhead", icon: "mdi-clock-outline", bottom: true },
    { name: "Applications", short: "Apps", route: "/AllApplicationsCwwministerial", icon: "mdi-file-document-multiple-outline", bottom: true },
    { name: "Approved Applications", route: "/ApprovedApplicationsCwwministerial", icon: "mdi-check-decagram-outline" },
    { name: "Cancelled Applications", route: "/CancelledApplicationCwwministerial", icon: "mdi-close-circle-outline" },
  ],
  dcf: [
    { name: "Dashboard", short: "Home", route: "/DcfDashboard", icon: "mdi-view-dashboard-outline", bottom: true },
    { name: "Profile", route: "/profilepage", icon: "mdi-account-circle-outline" },
    { name: "Pending Applications", short: "Pending", route: "/DcfPending", icon: "mdi-clock-outline", bottom: true },
    { name: "Applications", short: "Apps", route: "/AllApplicationsDcf", icon: "mdi-file-document-multiple-outline" },
    { name: "Approved Applications", route: "/ApprovedApplicationsDcf", icon: "mdi-check-decagram-outline" },
    { name: "Cancel Requests", short: "Cancel Req", route: "/CancelRequestDcf", icon: "mdi-cancel", bottom: true },
    { name: "Cancelled Applications", short: "Cancelled", route: "/CancelledApplicationDcf", icon: "mdi-close-circle-outline", bottom: true },
  ],
};

// Roles that get the Help page (nodal officer contact + rules & circulars)
const helpRoles = ["adminclerk", "division", "adminsuperint", "dcf", "clerk", "superint", "admin"];
const helpItem = { name: "Help", route: "/help", icon: "mdi-help-circle-outline" };

export function getNavItems(userType) {
  let items = menus[userType] || menus.division;
  if (helpRoles.includes(userType)) {
    items = [...items, userType === "admin" ? { ...helpItem, section: "Support" } : helpItem];
  }
  // Super admin sees pending applications through the Applications status filter,
  // and gets the all-roles Users List instead of the head-office one.
  if (isSuperAdmin()) return items.filter((item) => !item.hideForSuperAdmin && !item.adminOnly);
  return items.filter((item) => !item.superAdminOnly);
}

// Flat list of every link, including the ones nested under a group.
export function flattenNavItems(items) {
  return items.reduce((all, item) => all.concat(item.children ? item.children : [item]), []);
}
